import { Controller } from "@hotwired/stimulus"

// AI-powered description generator for services
// Sends the service name to a backend endpoint and receives a generated description

export default class extends Controller {
  static targets = ["input", "nameInput", "button", "spinner"]
  static values = {
    url: { type: String, default: "/services/generate_description" }
  }

  connect() {
    this.isGenerating = false
  }

  async generate(event) {
    event.preventDefault()

    if (this.isGenerating) return

    // Get the service name
    const serviceName = this.nameInputTarget?.value?.trim()
    if (!serviceName) {
      if (window.showToast) {
        window.showToast("Please enter a service name first", "error")
      }
      return
    }

    this.isGenerating = true
    this.updateButtonState()

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ name: serviceName })
      })

      if (!response.ok) {
        throw new Error("Failed to generate description")
      }

      const data = await response.json()

      if (data.description) {
        this.inputTarget.value = data.description
        // Trigger input event for any listeners (like the preview)
        this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))

        if (window.showToast) {
          window.showToast("Description generated!", "success")
        }
      } else if (data.error) {
        throw new Error(data.error)
      }
    } catch (error) {
      console.error("AI description error:", error)
      if (window.showToast) {
        window.showToast(error.message || "Failed to generate description", "error")
      }
    } finally {
      this.isGenerating = false
      this.updateButtonState()
    }
  }

  updateButtonState() {
    if (!this.hasButtonTarget) return

    if (this.isGenerating) {
      this.buttonTarget.disabled = true
      if (this.hasSpinnerTarget) {
        this.spinnerTarget.classList.remove("hidden")
      }
    } else {
      this.buttonTarget.disabled = false
      if (this.hasSpinnerTarget) {
        this.spinnerTarget.classList.add("hidden")
      }
    }
  }
}
